import * as React from 'react';
import { Button } from '../button/button';
import { ButtonVariant } from '../button/button.type';
import type { LinkListProps } from './link-list.types';

export const LinkList: React.FC<LinkListProps> = ({
	listName,
	items,
	className,
	listNameClassName,
	itemsClassName,
	itemClassName,
}) => {
	return (
		<div data-aid="LinkList" className={`flex flex-col ${className || ''}`}>
			<div className={`flex flex-wrap items-center gap-2`}>
				<div className={`text-sm text-primary whitespace-nowrap ${listNameClassName || ''}`}>{listName}:</div>
				<div className={`flex items-center flex-wrap gap-1 ${itemsClassName || ''}`}>
					{items.map(item => (
						<Button
							key={item.id}
							variant={ButtonVariant.HYPERLINK}
							size="xs"
							onClick={item.onclick}
							aria-label={`${listName} ${item.name}`}
							className={`${itemClassName || ''}`}
						>
							<span>#{item.name}</span>
						</Button>
					))}
				</div>
			</div>
		</div>
	);
};

LinkList.displayName = 'LinkList';
